const meta = {
  'change-events': 'Change events',
  'time-units': 'Time units',
  dictionary: 'Dictionary',
  'distributed-tracing': 'Distributed tracing',
};

export default meta;
